import { render, staticRenderFns } from "./StockPrint4.vue?vue&type=template&id=517a5772&scoped=true&"
import script from "./StockPrint4.vue?vue&type=script&lang=js&"
export * from "./StockPrint4.vue?vue&type=script&lang=js&"
import style0 from "./StockPrint4.vue?vue&type=style&index=0&id=517a5772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a5772",
  null
  
)

export default component.exports